<script lang="ts" setup>
import InputGroup from 'primevue/inputgroup';
</script>

<template>
  <InputGroup>
    <slot></slot>
  </InputGroup>
</template>
